import { prefersReducedMotion } from '@theme/utilities';

/**
 * Reveals top-level content sections as they scroll into view.
 */
function initScrollReveal() {
  if (prefersReducedMotion()) return;

  const sections = document.querySelectorAll('#MainContent .shopify-section');
  if (!sections.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('scroll-reveal-visible');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  sections.forEach((section) => observer.observe(section));
}

initScrollReveal();
